import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { PQRCargaHorarioEnsinoDto } from '../../dtos/pqr-carga-horaria-ensino.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'

interface ListPQRCargaHorarioEnsino {
  _embedded: {
    'pqr-carga-horaria-ensino': PQRCargaHorarioEnsinoDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRCargaHorarioEnsinoService {
  private apiUrl = `${environment.apiUrl}/pqr-carga-horaria-ensino`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRCargaHorarioEnsino(): Observable<PQRCargaHorarioEnsinoDto[]> {
    return this.caqRequestService
      .get<ListPQRCargaHorarioEnsino>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-carga-horaria-ensino']));
  }

  salvePQRCargaHorariaEnsino(requisicao: PQRCargaHorarioEnsinoDto){
    return firstValueFrom(this.caqRequestService
      .put<PQRCargaHorarioEnsinoDto>(`${this.apiUrl}/${requisicao.codPqrCargaHorariaEnsino}`, requisicao)
      .pipe(map((response) => response)));
  }
}
